import styled from 'styled-components'

const Container = styled.div<{ isFromEdit: boolean }>`
  width: 100%;
  background-color: var(--color-white);
  position: relative;
  padding-top: ${({ isFromEdit }) => (isFromEdit ? '8px' : '24px')};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

const Title = styled.p`
  margin: 0;
  margin-right: auto;
  font-size: 14px;

  font-weight: ${({ isFromEdit }) => (isFromEdit ? '400' : '700')};
  color: ${({ isFromEdit }) => (isFromEdit ? 'var(--color-text-secondary)' : 'var(--color-text-primary)')};
`

const Form = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 16px;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
`

const DisableScreen = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  bottom: 0;
  opacity: 0.3;
  background-color: var(--color-selago-grey);
`

const Textarea = styled.textarea<{ isError: boolean; isFromEdit: boolean }>`
  position: relative;
  width: 100%;
    height: 110px;
  // height: ${({ isFromEdit }) => (isFromEdit ? '250px' : '176px')};
  font-size: 14px;
  word-break: break-word;
  outline: none;
  border: none;
  //resize: none;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

const Error = styled.div`
  font-size: 12px;
  position: relative;
  color: var(--color-text-error);
  margin-top: -0.5rem;
  margin-right: auto;
`

const InputContainer = styled.div<{ isError: boolean; isFromEdit: boolean }>`
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 10px;

  * {
    padding: 1rem;
    border-radius: inherit;
  }

  & input {
    font-weight: 600;
    font-size: ${({ isFromEdit }) => (isFromEdit ? '14px' : '16px')};
    color: rgb(68, 68, 68);
    border-color: rgb(229, 229, 229);
    border-bottom: none;
    border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
  }
`

const TitleInput = styled.input`
  font-weight: 600;
  font-size: ${({ isFromEdit }) => (isFromEdit ? '14px' : '16px')};
  color: rgb(68, 68, 68);
  border: none;
  outline: none;
  width: 100%;
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  width: 100%;
  gap: 8px;
  position: relative;
  justify-content: flex-end;
`

export {
  Container,
  Title,
  Form,
  DisableScreen,
  Textarea,
  Error,
  InputContainer,
  TitleInput,
  Footer,
}
